import { useCustom } from '@refinedev/core';
import { PenTool, UserPlus, Target, DollarSign } from 'lucide-react';
import type { FC } from 'react';
import StatCard from '@/components/common/StatCard';

interface MarketingDashboardData {
  contentsGenerated: number;
  contentsThisMonth: number;
  prospectsContacted: number;
  prospectsThisWeek: number;
  referralConversionRate: number;
  referralConversionLastMonth: number;
  estimatedMRR: number;
  mrrGrowth: number;
}

const MarketingKPICards: FC = () => {
  const { data, isLoading } = useCustom<{ data: MarketingDashboardData }>({
    url: '/api/v1/admin/marketing/dashboard',
    method: 'get',
    queryOptions: { retry: false },
  });

  const MOCK: MarketingDashboardData = {
    contentsGenerated: 147, contentsThisMonth: 23,
    prospectsContacted: 89, prospectsThisWeek: 12,
    referralConversionRate: 34.2, referralConversionLastMonth: 28.5,
    estimatedMRR: 4850, mrrGrowth: 18.3,
  };

  const stats = data?.data?.data ?? MOCK;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        title="Contenus générés"
        value={stats?.contentsGenerated}
        icon={PenTool}
        iconColor="text-emerald-600 dark:text-emerald-400"
        iconBg="bg-emerald-50 dark:bg-emerald-900/30"
        loading={isLoading}
        trend={stats?.contentsThisMonth ? { value: stats.contentsThisMonth, isPositive: true, label: 'ce mois' } : undefined}
      />
      <StatCard
        title="Prospects contactés"
        value={stats?.prospectsContacted}
        icon={UserPlus}
        iconColor="text-blue-600 dark:text-blue-400"
        iconBg="bg-blue-50 dark:bg-blue-900/30"
        loading={isLoading}
        trend={stats?.prospectsThisWeek ? { value: stats.prospectsThisWeek, isPositive: true, label: 'cette semaine' } : undefined}
      />
      <StatCard
        title="Taux conversion Referral"
        value={stats?.referralConversionRate != null ? `${stats.referralConversionRate}%` : undefined}
        icon={Target}
        iconColor="text-violet-600 dark:text-violet-400"
        iconBg="bg-violet-50 dark:bg-violet-900/30"
        loading={isLoading}
        trend={stats?.referralConversionLastMonth != null
          ? { value: stats.referralConversionLastMonth, isPositive: stats.referralConversionRate > stats.referralConversionLastMonth, label: `vs ${stats.referralConversionLastMonth}%` }
          : undefined}
      />
      <StatCard
        title="MRR estimé"
        value={stats?.estimatedMRR != null ? `${stats.estimatedMRR.toLocaleString('fr-FR')} €` : undefined}
        icon={DollarSign}
        iconColor="text-amber-600 dark:text-amber-400"
        iconBg="bg-amber-50 dark:bg-amber-900/30"
        loading={isLoading}
        trend={stats?.mrrGrowth != null ? { value: stats.mrrGrowth, isPositive: stats.mrrGrowth > 0, label: '%' } : undefined}
      />
    </div>
  );
};

export default MarketingKPICards;
